import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const SearchBar = ({
	searchPlaceholder,
	setSearchQuery
}: {
	searchPlaceholder: string;
	setSearchQuery: (value: string) => void;
}) => {
	const [searchInputValue, setSearchInputValue] = useState();

	const onChange = (e: any) => setSearchInputValue(e.target.value);
	return (
		<div
			className="min-w-200 flex items-center justify-start
                    bg-gray-100 dark:bg-gray-600 text-gray-500 px-2 h-9 ml-0 mr-0 
                      rounded-md shadow-md transition duration-500 ease-in-out"
		>
			<input
				className="w-full font-sans font-semibold bg-transparent outline-none 
                        text-gray-800 dark:text-white placeholder-gray-500 pl-1 rounded"
				type="text"
				placeholder={searchPlaceholder}
				onChange={onChange}
				value={searchInputValue}
			/>
			<FaSearch
				size="18"
				className="text-purple-600 my-auto cursor-pointer"
				onClick={() => {
					if (searchInputValue != null) setSearchQuery(searchInputValue);
				}}
			/>
		</div>
	);
};

export default SearchBar;
